import React from "react";
import styled from "styled-components";

const StyledGuestBadge = styled.div`
    padding: 4px 5px;
    justify-content: center;
    border-radius: 3px;
    background: #FFF0E3;
    color: #FA901F;
    font-family: "Source Sans Pro";
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    height: fit-content;
    align-self: center;
`;

const GuestBadge = () => <StyledGuestBadge>GUEST</StyledGuestBadge>;

export default GuestBadge;
